import invoiceModule from "./invoiceModule"
import invoiceView from "./invoiceView.html"

invoiceModule.config(["editionServiceProvider", (editionServiceProvider) =>{
    editionServiceProvider.registerEdition("invoice", invoiceView, "invoiceController")
}])